import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, UseFormReturn } from 'react-hook-form';
import { Col, FormFeedback, Input, Label, Row } from 'reactstrap';

type PropsTypes = {
  form: UseFormReturn<any, object>;
};

export const MedicalFormGeneralInformation = (props: PropsTypes) => {
  const { t } = useTranslation();

  const idLengthValidation = (value: string): any => {
    if (value.length !== 9) {
      return 'Id number must be 9 characters';
    }
  };

  const {
    control,
    formState: { errors },
  } = props.form;

  return (
    <>
      <Row>
        <Col md="4" className="form-user-input">
          <Label for="fullName">
            {t('MEDICAL_DECLARATION_FULL_NAME_LABEL')}
          </Label>
          <Controller
            name="fullName"
            control={control}
            rules={{
              required: {
                value: true,
                message: t('FORM_ERRORS_FIELD_IS_REQUIRED'),
              },
              pattern: {
                value: /^[0-9a-zA-Z _"'.\u0590-\u05FF\u200f\u200e]*$/,
                message: t('FORM_ERRORS_INVALID_USE_LETTERS_NUMBER'),
              },
              minLength: {
                value: 2,
                message: t('FORM_ERRORS_FIELD_TOO_SHORT'),
              },
            }}
            render={({ field }) => (
              <Input
                disabled={true}
                id="fullName"
                autoComplete="off"
                type="text"
                className="text-input"
                placeholder={t('MEDICAL_DECLARATION_FULL_NAME_LABEL')}
                invalid={errors.fullName && true}
                {...field}
              />
            )}
          />
          {errors.fullName ? (
            <FormFeedback className="form-input-error">
              {errors.fullName.message}
            </FormFeedback>
          ) : null}
        </Col>
        <Col md="4" className="form-user-input">
          <Label for="idNumber">
            {t('MEDICAL_DECLARATION_ID_NUMBER_LABEL')}
          </Label>
          <Controller
            name="idNumber"
            control={control}
            rules={{
              required: {
                value: true,
                message: t('FORM_ERRORS_FIELD_IS_REQUIRED'),
              },
              validate: {
                idLengthValidation: (e) => idLengthValidation(e),
              },
            }}
            render={({ field }) => (
              <Input
                id="idNumber"
                type="number"
                placeholder={t('MEDICAL_DECLARATION_ID_NUMBER_PLACEHOLDER')}
                invalid={errors.idNumber && true}
                {...field}
              />
            )}
          />
          {errors.idNumber ? (
            <FormFeedback className="form-input-error">
              {errors.idNumber.message}
            </FormFeedback>
          ) : null}
        </Col>
        <Col md="4" className="form-user-input">
          <Label for="age">{t('MEDICAL_DECLARATION_AGE_LABEL')}</Label>
          <Controller
            name="age"
            control={control}
            rules={{
              required: {
                value: true,
                message: t('FORM_ERRORS_FIELD_IS_REQUIRED'),
              },
              min: {
                value: 1,
                message: t('MUST_BE_GREATER_THAN', { value: 0 }),
              },
              maxLength: {
                value: 3,
                message: t('FORM_ERRORS_FIELD_TOO_LONG'),
              },
            }}
            render={({ field }) => (
              <Input
                id="age"
                type="number"
                placeholder={t('MEDICAL_DECLARATION_AGE_LABEL')}
                invalid={errors.age && true}
                {...field}
              />
            )}
          />
          {errors.age ? (
            <FormFeedback className="form-input-error">
              {errors.age.message}
            </FormFeedback>
          ) : null}
        </Col>
      </Row>
    </>
  );
};
